import React, {useContext, useEffect, useState} from 'react'
import {Form, Select} from "antd";
import {UserContext} from "@context/UserContext";
import {BrandContext} from "@context/BrandContext";
import Button from "@common/Button";

const AccountSettingsClassesSchoolYear = props => {
    const {userDetails, data, checkFormStatus, handleSubmitForm} = props;
    const [initialFormValues, setInitialFormValues] = useState({});
    const [submittable, setSubmittable] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [form] = Form.useForm();
    const {user} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);

    useEffect(() => {
        if (userDetails) {
            const newInitialValues = {
                schoolYear: userDetails.schoolYear
            };
            form.setFieldsValue(newInitialValues);
            setInitialFormValues(newInitialValues);
        }
    }, [userDetails, data, form]);

    const handleSubmitFormWrapper = (values) => {
        setDisabled(true);
        handleSubmitForm(form, values, initialFormValues, '/web/ui/accountSettings/updateUsersSchoolDetails', () => {
            displayToastMessage('Update successful', '', 'success', undefined, 4000);
            setInitialFormValues(values);
            setDisabled(false);
        }, () => {
            setDisabled(false);
        });
    }

    return (
        <>
            <h3>Classes and school year</h3>
            <Form
                name="schoolDetails"
                form={form}
                layout="vertical"
                onFieldsChange={() => setSubmittable(checkFormStatus(form))}
                onFinish={handleSubmitFormWrapper}
            >
                <span className="ant-form-item-label">School</span>
                <p>
                    <b>{userDetails?.schoolName}</b>
                </p>
                {user.teacher || !brandConfig.hideStudentClasses && (
                    <>
                        <span className="ant-form-item-label">Class</span>
                        <p>
                            {user?.classes.length > 0 ? (
                                <b>
                                    {user.classes.map((clazz, index) => {
                                        return <span key={clazz.classId}>{(index > 0 ? ', ' : '') + clazz.className}</span>;
                                    })}
                                </b>
                            ) : (
                                <b>(none)</b>
                            )}
                        </p>
                    </>
                )}
                <Form.Item
                    label="School Year"
                    name="schoolYear"
                >
                    <Select>
                        {data?.schoolYears.map(schoolYear => {
                            const [value, label] = Object.entries(schoolYear)[0];
                            return (
                                <Select.Option key={value} value={value}>
                                    {label}
                                </Select.Option>
                            );
                        })}
                    </Select>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" disabled={disabled ? disabled : !submittable}>
                        Save changes
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}

export default AccountSettingsClassesSchoolYear;